import { isVatId, normalizeVatId } from '@pulsify/shared/dto'

/** Whether the signed-in roles may change the company details: the owner or a Pulsify admin. */
export function canEditCompanyDetails(roles: readonly string[]): boolean {
  return roles.includes('business_admin') || roles.includes('global_admin')
}

/** Whether a typed VAT number (UID) is empty or looks like one, the way the server checks it. */
export function isValidVatInput(value: string): boolean {
  return isVatId(normalizeVatId(value))
}
